import clsx from 'clsx';
import Image from 'next/image';

import { ISlotReview } from 'constants/types';
import dayjs from 'dayjs';
import { Routes } from 'constants/routes';

import styles from './styles.module.css';

type Props = {
  data: ISlotReview;
  hasLowRating?: boolean;
};

export const ReviesUser = ({ data, hasLowRating }: Props) => {
  return (
    <a
      href={Routes.publicProfile(data?.user?._id ?? '')}
      className={styles.slot_review__user}
    >
      <div className={styles.slot_review__user_info}>
        <div className={styles.slot_review__user_photo}>
          <Image
            width={50}
            height={50}
            alt={data?.imageUrl}
            src={data?.user?.imageUrl ?? ''}
          />
        </div>
        <div className={styles.slot_review__user_abouts}>
          <div className={styles.slot_review__user_about}>
            <div className={styles.slot_review__user_name}>
              {data.user.username}
            </div>
            <div className={styles.slot_review__user_inspections}>
              {data?.user?.inspections_count === 1
                ? `${data?.user?.inspections_count} inspection`
                : `${data?.user?.inspections_count} inspections`}
            </div>
          </div>
          <div className={styles.slot_review__user_about}>
            <div
              className={clsx(
                styles.slot_review__user_rtpi,
                styles.slot_review__user_rtpi_top
              )}
            >
              <span
                className={clsx(
                  data?.value >= 95 && !hasLowRating
                    ? styles.highRtp
                    : styles.lowRtp
                )}
              >
                {`${(data.value ?? 0)?.toFixed(2)}%`}
              </span>
            </div>
            <div className={styles.slot_review__user_rated}>
              {`rated ${dayjs(data.createdAt).format('DD MMM YYYY')}`}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.slot_review__user_arrow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
        >
          <path
            d="M13.0605 23.5605L21.621 15L13.0605 6.43945L10.9395 8.56045L17.379 15L10.9395 21.4395L13.0605 23.5605Z"
            fill="white"
            fillOpacity="0.4"
          />
        </svg>
      </div>
    </a>
  );
};
